export const env = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV;

const environment = require(`./environments/env.${env.trim()}.json`);
export default environment;
